export default function WhoIsThisProductFor() {
    return {
        title: 'Who is this Product for?',
        paragraphs: [
            '<div>Review your book of business for opportunities:<div>',
            '<ul><li>Late career (40+)</li><li>On-track and at-risk clients in Goals Planning System</li></ul>',
            '<div>Conversation Starters:</div>',
            '<ul class="mb-0"><li>If you need extended care due to a situation such as Alzheimer’s, what are the assets that will be used to pay for care?</li><li>If you need extended care, where would you prefer that occur? At home or an assisted living community? Is your family aware of your desires?</li><li>If you are planning on self-insuring for long-term care, are you interested in looking at a way to leverage that self-insurance?</li><li>Do you have a bank CD maturing and are also looking to plan for extended care?</li></ul>',
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/asset-based-ltc/WhoIsThisProductData.js